/**
 * Standard audit-field columns for <AdvancedTable>.
 *
 * Usage:
 *   import { auditColumns } from "@/components/table/auditColumns";
 *   const columns = [ ...myColumns, ...auditColumns() ];
 *
 * All columns default to hidden so the tabular view stays compact; the user
 * can turn them on from the Columns menu. Column keys stay in sync with the
 * backend record shape (`created_at`, `created_by_name`, etc.).
 */
import { fmtRelative } from "@/lib/format";

export function auditColumns({ hidden = true } = {}) {
  const commonHidden = hidden ? { visible: false } : {};
  return [
    {
      key: "created_by_name",
      label: "Created by",
      width: 140,
      sortable: true,
      filterType: "text",
      ...commonHidden,
      render: (row) => (
        <span className="text-xs text-muted-foreground" data-testid={`audit-created-by-${row.id || ""}`}>
          {row.created_by_name || "—"}
        </span>
      ),
      exportValue: (row) => row.created_by_name || "",
    },
    {
      key: "created_at",
      label: "Created on",
      width: 130,
      sortable: true,
      align: "right",
      filterType: "date-range",
      ...commonHidden,
      render: (row) => (
        <span className="text-xs text-muted-foreground">
          {row.created_at ? fmtRelative(row.created_at) : "—"}
        </span>
      ),
      exportValue: (row) => row.created_at || "",
    },
    {
      key: "updated_by_name",
      label: "Updated by",
      width: 140,
      sortable: true,
      filterType: "text",
      ...commonHidden,
      render: (row) => (
        <span className="text-xs text-muted-foreground">
          {row.updated_by_name || "—"}
        </span>
      ),
      exportValue: (row) => row.updated_by_name || "",
    },
    {
      key: "updated_at",
      label: "Updated on",
      width: 130,
      sortable: true,
      align: "right",
      filterType: "date-range",
      ...commonHidden,
      render: (row) => (
        <span className="text-xs text-muted-foreground">
          {row.updated_at ? fmtRelative(row.updated_at) : "—"}
        </span>
      ),
      exportValue: (row) => row.updated_at || "",
    },
  ];
}
